import { render, staticRenderFns } from "./CliniciansAssigned.vue?vue&type=template&id=e6cdc4aa"
import script from "./CliniciansAssigned.vue?vue&type=script&lang=js"
export * from "./CliniciansAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports